import { useState, useCallback } from 'react';

/**
 * Hook reutilizable para manejar navegación por vistas dentro de un módulo.
 * 
 * @param {string} initialView - Nombre de la vista inicial (por defecto 'dashboard')
 * @param {object} viewsMap - Objeto que asocia nombres de vista con componentes React.
 */
export const useModuleView = (initialView = 'dashboard', viewsMap = {}) => {
  const [view, setView] = useState(initialView);
  const [contextData, setContextData] = useState(null);

  // Cambia de vista y opcionalmente pasa datos (por ejemplo item seleccionado)
  const navigateTo = useCallback((nextView, data = null) => {
    setView(nextView);
    setContextData(data);
  }, []);

  // Retorna el componente actual
  // const renderView = useCallback(() => {
  //   const ViewComponent = viewsMap[view];
  //   if (!ViewComponent) return <div>⚠️ Vista "{view}" no encontrada.</div>;
  //   return <ViewComponent navigateTo={navigateTo} data={contextData} />;
  // }, [view, contextData, navigateTo, viewsMap]);

  // Actualizacion
  const renderView = useCallback(
    (extraProps = {}) => {
      const ViewComponent = viewsMap[view];
      if (!ViewComponent) return <div>Vista no encontrada</div>;
      return (
        <ViewComponent
          navigateTo={navigateTo}
          data={contextData}
          {...extraProps}
        />
      );
    },
    [view, contextData, navigateTo, viewsMap]
  );

  return {
    view,
    setView: navigateTo,
    contextData,
    renderView,
    isView: (v) => v === view,
  };
};
